// src/components/organisms/Learning/DroppableWord.tsx
import { useDroppable } from '@dnd-kit/core'
import * as styles from '@/components/interAction/Drag/DragStyle.css'
import { vars } from '@/style/theme.css'

export function TargetWord({
  id,
  label,
  isMatched,
}: {
  id: string
  label: string
  isMatched?: boolean
}) {
  const { setNodeRef, isOver } = useDroppable({ id })

  return (
    <div
      ref={setNodeRef}
      className={styles.wordWrapper}
      style={{
        backgroundColor: isMatched ? 'white' : isOver ? vars.color.gray[100] : 'white',
        border: `1px solid ${
          isMatched
            ? vars.color.primary[500]
            : isOver
            ? vars.color.gray[300]
            : vars.color.gray[100]
        }`,
      }}
    >
      <span className="p-2 text-sm font-bold text-center">{label}</span>
    </div>
  )
}       